<template>
    <div class="page page-my-awards bg-red">
        <div class="page__inner">
            <div class="sect">
                <div v-if="myOpenId" class="mod my-awards-list">
                    <div class="mod__hd">
                        <h1 class="mod__h1 ta_center">账号绑定成功</h1>
                    </div>
                    <div class="mod_bd">
                        <div class="mod__txt">
                            <dl>
                                <dd>&emsp;&emsp;恭喜您，您的新浪账号(ID: <span class="red">{{myOpenId}}</span>)绑定成功！</dd>
                                <dd>&emsp;&emsp;我们会将新浪《碎片化创新语音课》奖品权益发放到该账号；其他奖项，我们会在一周内开通权限、发送奖品。请及时查收你的奖品。</dd>
                                <dd>&nbsp;</dd>
                                <dd>&emsp;&emsp;如有疑问请联系客服 <a class="blue" href="tel:4006776878">400-677-6878</a>。</dd>
                            </dl>
                            <dl v-if="needAddress">
                                <dd>&emsp;</dd>
                                <dd class="red">由于发放实物奖品需要地址等信息，请填写你的领奖信息。</dd>
                                <dd>&nbsp;</dd>
                                <dd> </dd>
                            </dl>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-else class="page__inner">
            <txt-loading />
        </div> -->
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'
    import MyAwardsNotice from './awards/notice'

    export default {
        components: {
            [MyAwardsNotice.name] : MyAwardsNotice
        },
        computed: {
            ...mapState(['myOpenId']),
            ...mapGetters(['needAddress'])
        },
        methods: {
            ...mapActions(['loadMyOpenId', 'goBind'])
        },
        async created() {
            this.loadMyOpenId()
            if(!this.myOpenId) {
                this.$router.replace('/match/my/awards')
            }
        }
    };

</script>
